module.exports = __webpack_public_path__ + "static/media/us-cranberries.3f3178ea.png";